module.exports = __webpack_public_path__ + "static/media/download.941ba439.svg";